module.exports = __webpack_public_path__ + "80fa5b8d783a8812f05a03fa3b90d241.fbx";